export default "__VITE_ASSET__BsTM0AVs__"